export default [
  {
    path: "/usuario/perfil",
    name: "user-profile",
    component: () => import("../views/user/Edit.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true
    }
  },
  {
    path: "/usuario/preferencias",
    name: "user-preferences",
    component: () => import("../views/Preferences.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true
    }
  },
  {
    path: "/usuario/dados-pessoais",
    name: "user-personal-data",
    component: () => import("../views/user/PersonalData.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      viewContainer: true,
      breadcrumbs: ["user-personal-data"]
    }
  },
  {
    path: "/usuario/dados-financeiros",
    name: "user-financial-data",
    component: () => import("../views/user/FinancialData.vue"),
    meta: {
      template: () => import("../templates/Default.vue"),
      protected: true,
      breadcrumbs: ["user-financial-data"],
      viewContainer: true
    }
  }
];
